// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"1c5cf108","78":"1c5cf108","151":"1c5cf108","334":"1c5cf108","391":"a2f7bf6c","720":"1c5cf108","953":"a2f7bf6c"}[chunkId] + ".chunk.css";
};